import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {FetchMetricsOptionsModel} from '../models/fetch-metrics-options.model';
import {FetchMetricValuesModel} from '../models/fetch-metric-values.model';
import {v1URL} from '../../../shared/constants/urls.constants';
import {CommonService} from '../../../shared/services/common.service';
import {DeleteMetricValueModel} from '../models/delete-metric-value.model';
import {EditMetricValueModel} from '../models/edit-metric-value.model';
import {AddMetricValueModel} from '../models/add-metric-value.model';
import {DeleteMetricValueListModel} from '../models/delete-metric-value-list.model';
import {EditMetricValueListModel} from '../models/edit-metric-value-list.model';

@Injectable({
  providedIn: 'root',
})

export class MetricsService {
  constructor(
    private commonServices: CommonService
  ) {
  }

  fetchMetricsOptions(payload: FetchMetricsOptionsModel['request']): Observable<FetchMetricsOptionsModel['response']> {
    const urlConfig = v1URL.measurements.options.fetchAll
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchMetrics(payload: FetchMetricValuesModel['request']): Observable<FetchMetricValuesModel['response']> {
    const urlConfig = v1URL.measurements.values.fetchAll;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  addMetricValue(payload: AddMetricValueModel['request']): Observable<AddMetricValueModel['response']> {
    const urlConfig = v1URL.measurements.values.add
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(), payload);
  }

  editMetricValue(payload: EditMetricValueModel['request']): Observable<EditMetricValueModel['response']> {
    const params = {
      valueId: payload.valueId
    }
    const body = {
      recordedOn: payload.recordedOn,
      value: payload.value,
    }
    const urlConfig = v1URL.measurements.values.update
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(params), body);
  }

  deleteMetricValue(payload: DeleteMetricValueModel['request']): Observable<DeleteMetricValueModel['response']> {
    const urlConfig = v1URL.measurements.values.remove
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  deleteMetricValueList(payload: DeleteMetricValueListModel['request']): Observable<DeleteMetricValueListModel['response']> {
    const urlConfig = v1URL.measurements.values.removeMultiple
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(), payload);
  }

  editMetricValueList(payload: EditMetricValueListModel['request']): Observable<EditMetricValueListModel['response']> {
    const urlConfig = v1URL.measurements.values.updateMultiple
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(), payload);
  }
}
